import 'select2';
import $ from 'jquery';

$(document).ready(() => {
  function defaultSettings(element) {
    const options = {
      width: '100%',
      minimumInputLength: 3,
    };

    if (element.data('select-dropdown-parent') !== undefined) {
      const id = element.data('select-dropdown-parent');
      options.dropdownParent = $(id);
    }

    return options;
  }

  $('.location-select2').each(function(index, element) {
    const select = $(element);
    const options = defaultSettings(select);

    options.ajax = {
      url: '/location',
      dataType: 'json',
      method: 'POST',
    };

    select.select2(options);
  });

  $('.location-geocode-select2').each(function(index, element) {
    const select = $(element);
    const options = defaultSettings(select);

    options.ajax = {
      url: '/location/geocode',
      dataType: 'json',
      method: 'POST',
    };

    select.select2(options);
  });

  $('.location-address-select2').each(function(index, element) {
    const select = $(element);
    const options = defaultSettings(select);

    options.ajax = {
      url: '/location/address',
      dataType: 'json',
      method: 'POST',
    };

    select.select2(options);
  });
});
